import { render, staticRenderFns } from "./load_current_gear.vue?vue&type=template&id=1d096704"
import script from "./load_current_gear.vue?vue&type=script&lang=ts"
export * from "./load_current_gear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports